function merge() {
    var objs = Array.prototype.slice.call(arguments);
    var obj = {};

    for(var i in objs) {
        var o = objs[i];

        for(var p in o) {
            try {
                if (o[p].constructor == Object) {
                    obj[p] = _merge(obj[p], o[p]);
                } else {
                    obj[p] = o[p];
                }

            } catch(e) {
                obj[p] = o[p];
            }
        }
    }

    return obj;
}

module.exports = merge;
